<template>
  <div v-if="isMGMAndMO || !(status !== 'Draft' && status !== 'Verification' && serviceList.length === 0)">
    <div class="clearfix my-3">
      <h4 class="card-title float-start">
        {{ $t('maintenance.order.serviceList') }}
      </h4>
      <div v-if="hasData" class="float-end">
        <McButton
          v-if="isEditable"
          v-b-modal.service-add
          icon="icon-fill_plus"
          :text="$t('global.create')"
          variant="primary"
        />
      </div>
    </div>

    <b-card v-if="hasData && render">
      <div
        v-for="(item, index) in serviceList"
        :key="index"
        class="accordion mc-accordion"
        role="tablist"
      >
        <div class="mc-accordion-item">
          <div header-tag="header" role="tab" class="mc-accordion__header">
            <b-row>
              <b-col md="4">
                <span class="d-block mb-1 teal-300">{{ $t('maintenance.form.compService') }}</span>
                <h5
                  v-if="item.service?.name || item.service?.serviceAction.action"
                >
                  {{ item.service?.name ?? '-'}}  
                  {{ ` (${item.service?.serviceAction.action ?? '-'})` }}
                </h5>
              </b-col>
              <b-col md="2">
                <span class="d-block mb-1 teal-300">{{
                  $t('maintenance.order.form.serviceType')
                }}</span>
                <McBadge
                  :variant="item.serviceType == 'Insidental' ? 'outlinePurple' : 'outlineInfo'"
                  size="medium"
                  type="button"
                  :text="$t('maintenance.order.serviceType.' + item.serviceType)"
                />
              </b-col>
              <b-col md="2">
                <div v-if="item.serviceType != 'Insidental'">
                  <span class="d-block mb-1 teal-300">{{
                    $t('maintenance.field.statusService')
                  }}</span>
                  <span v-if="item.format" :class="`mc-status mc-status--${item.format.color}`">
                    {{ item.format.label }}
                  </span>

                  <p v-else>-</p>
                </div>
              </b-col>
              <b-col md="2">
                <span class="d-block mb-1 teal-300">{{
                  $t('maintenance.order.form.partsPrice')
                }}</span>
                <h5>{{ item.totalPrice ? 'Rp ' + thousandFormat(item.totalPrice) : 'Rp 0' }}</h5>
              </b-col>
              <b-col md="2" class="text-end">
                <i
                  v-if="isEditable"
                  id="delete-accordion"
                  class="mc-fa icon-outline_trash"
                  @click="handleDelete(item.service2SoId, item.serviceId)"
                ></i>
                <span v-b-toggle="`accordion-${index}`">
                  <i class="mc-fa icon-fill_arrow-ios-up"></i>
                  <i class="mc-fa icon-fill_arrow-ios-down"></i>
                </span>
              </b-col>
            </b-row>
          </div>
          <b-collapse :id="`accordion-${index}`" role="tabpanel">
            <div class="mc-accordion__body">
              <div
                v-if="item.serviceType != 'Insidental'"
                class="form-check form-switch mc-modal-info__options-item-custom-check-type"
              >
                <label class="form-check-label ms-1">
                  <input
                    v-model="detailInformation"
                    class="form-check-input"
                    type="checkbox"
                    name="check-button"
                    switch
                    :disabled="item?.serviceSchedule == null"
                  />{{ $t('maintenance.order.detailService') }}
                </label>
              </div>
              <b-row v-if="detailInformation" class="mt-4 mx-1 p-3 border">
                <b-col class="border-end">
                  <span class="d-block teal-300">{{
                    $t('maintenance.frontPage.title.serviceGroup')
                  }}</span>
                  <h6>{{ item.serviceSchedule?.ssgroup?.name ?? '-' }}</h6>
                </b-col>

                <b-col class="border-end">
                  <span class="d-block teal-300">{{ $t('maintenance.form.catService') }}</span>
                  <h6>{{ item.service?.serviceCategory?.name ?? '-' }}</h6>
                </b-col>

                <b-col class="border-end">
                  <span class="d-block teal-300">{{ $t('maintenance.field.method') }}</span>
                  <h6>{{ item.serviceSchedule?.method }}</h6>
                </b-col>

                <b-col v-if="item.serviceSchedule?.type == 'DistanceAndTime'" class="border-end">
                  <span class="d-block teal-300">{{ $t('maintenance.form.dateNextService') }}</span>
                  <h6>
                    {{ momentDateShortMonth(item.serviceSchedule?.startServiceAtTime) ?? '-' }}
                  </h6>
                </b-col>

                <b-col v-if="item.serviceSchedule?.type == 'DistanceAndTime'" class="border-end">
                  <span class="d-block teal-300">{{ $t('maintenance.form.timeDifference') }}</span>
                  <h6>
                    {{ item.serviceSchedule?.serviceTimeDifference !== null ? '' : '-' }}
                    {{ item.serviceSchedule?.serviceTimeDifference?.isDatePassed ? '-' : ''
                    }}{{
                      item.serviceSchedule?.serviceTimeDifference?.months == 0 &&
                      item.serviceSchedule?.serviceTimeDifference?.days == 0
                        ? `0 ${$t('global.time.days')}`
                        : `${
                            item.serviceSchedule?.serviceTimeDifference?.months
                              ? item.serviceSchedule?.serviceTimeDifference?.months +
                                ` ${$t('global.time.month')} `
                              : ''
                          }${
                            item.serviceSchedule?.serviceTimeDifference?.days
                              ? item.serviceSchedule?.serviceTimeDifference?.days +
                                ` ${$t('global.time.days')}`
                              : ''
                          }`
                    }}
                  </h6>
                </b-col>
                <b-col v-if="item.serviceSchedule?.type == 'DistanceAndTime'" class="border-end">
                  <span class="d-block teal-300">{{ $t('maintenance.form.odoNextService') }}</span>
                  <h6>
                    {{ thousandFormat(item?.serviceSchedule?.startServiceAtDistance) ?? '-' }} Km
                  </h6>
                </b-col>
                <b-col v-if="item.serviceSchedule?.type == 'DistanceAndTime'" class="border-end">
                  <span class="d-block teal-300">{{
                    $t('maintenance.form.kilometerDifference')
                  }}</span>
                  <h6>
                    {{ thousandFormat(item?.serviceSchedule?.serviceDistanceDifference) ?? '-' }} Km
                  </h6>
                </b-col>

                <b-col v-if="item.serviceSchedule?.type == 'Hourmeter'" class="border-end">
                  <span class="d-block teal-300">{{
                    $t('maintenance.form.hourmeterNextService')
                  }}</span>
                  <h6>
                    {{ minuteToHour(item.serviceSchedule?.startServiceAtHourmeter) ?? '-' }}
                  </h6>
                </b-col>

                <b-col v-if="item.serviceSchedule?.type == 'Hourmeter'">
                  <span class="d-block teal-300">{{
                    $t('maintenance.form.hourmeterDifference')
                  }}</span>
                  <h6>
                    {{ minuteToHour(item.serviceSchedule?.serviceHourmeterDifference) ?? '-' }}
                  </h6>
                </b-col>
              </b-row>
              <PartsTable
                ref="parts-table"
                :status="status"
                :apiClient="query"
                :service2SoId="+item.service2SoId"
                :fieldOptions="initialObject"
                :listDatas="partsList"
              />
            </div>
          </b-collapse>
        </div>
      </div>
    </b-card>

    <div v-if="!render">
      <b-card class="my-2">
        <b-skeleton
          v-for="item in serviceList"
          :key="item.service2SoId"
          width="100%"
          height="70px"
          class="mt-2"
        />
        <b-skeleton v-if="isAdding" width="100%" height="70px" class="mt-2" />
      </b-card>
    </div>

    <b-card v-if="!hasData && render">
      <McEmptyState
        :title="$t('maintenance.order.emptyState')"
        :desc="$t('maintenance.order.emptyStateText')"
        placementType="grid"
        @buttonPrimaryAction="$bvModal.show('service-add')"
      />
    </b-card>

    <!-- modal add, controlled by $bvModal.<show|hide>('service-add') -->
    <AddService :serviceIds="serviceIds" @addData="addData" />
  </div>
</template>
<script>
import appConfig from '@/app.config'
import McBadge from '@/components/McBadge'
import McEmptyState from '@/components/McEmptyState'
import AddService from './Modal/AddService.vue'
import McButton from '@/components/McButton'
import {
  GET_SERVICE_TO_SERVICE_ORDERS,
  CREATE_SERVICE_TO_SERVICE_ORDER,
  DELETE_SERVICE_TO_SERVICE_ORDER,
} from '@/services/api/maintenance/service2serviceorder'
import {
  GET_PART_TO_SERVICE_ORDER,
  CREATE_PART_TO_SERVICE_ORDER,
  UPDATE_PART_TO_SERVICE_ORDER,
  DELETE_PART_TO_SERVICE_ORDER,
  GET_PART_TO_SERVICE_ORDER_BY_ID,
} from '@/services/api/maintenance/part2serviceorder'
import unitOfMeasures from './lib/units'
import { GET_PARTS } from '@/services/api/master/spareparts'
import { Helper } from '@/mixin/helper'
import PartsTable from './Tables/PartsTable'
import { mapGetters } from 'vuex'

export default {
  page: {
    title: 'Servis',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  components: {
    McBadge,
    AddService,
    McEmptyState,
    PartsTable,
    McButton,
  },

  mixins: [Helper],

  apollo: {
    parts: {
      query: GET_PARTS,
      fetchPolicy: 'no-cache',
      result({ data, loading }) {
        if (!loading && data) this.partsList = data.parts.parts.data
      },
    },
  },

  props: ['status', 'totalKilometer', 'totalHourmeter'],

  data() {
    return {
      unitOfMeasures,
      hasData: true,
      detailInformation: false,
      serviceList: [],
      initialObject: {
        part: null,
        unit: null,
      },
      partsList: [],
      render: true,
      serviceIds: [],
      isEditable: false,
      isAdding: false,
    }
  },
  computed: {
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    isMGMAndMO() {
      const data = this.getFeatureFlagValue('customFeature.mgm')
      return (
        Array.isArray(data?.company_id) &&
        data.company_id.includes(this.getCompanyId()) &&
        data.features?.maintenance_order
      )
    },
    query() {
      return {
        get: async (filter) => {
          const res = await this.$apollo.query({
            query: GET_PART_TO_SERVICE_ORDER,
            fetchPolicy: 'no-cache',
            variables: {
              filter: filter,
            },
          })

          return res.data.part2Services.part2Services
        },
        getById: async (partId, id) => {
          const res = await this.$apollo.query({
            query: GET_PART_TO_SERVICE_ORDER_BY_ID,
            fetchPolicy: 'no-cache',
            variables: {
              filter: {
                partId,
                service2SoId: id,
              },
            },
          })

          return res.data.part2Service.part2Service
        },
        store: async (data, id) => {
          let input = {
            partId: data.part,
            price: data.price,
            qty: data.qty,
            service2SoId: +id,
            discount: data.discount,
            unit: data.unit,
            note: data.note,
          }

          const res = await this.$apollo.mutate({
            mutation: CREATE_PART_TO_SERVICE_ORDER,
            variables: {
              input: input,
            },
          })

          if (res.data.createPart2Service.isSuccessful) {
            const self = this
            self.get()
            self.$emit('update-total-price')

            return res.data.createPart2Service
          }
        },
        update: async (partId, oldData, newData, id) => {
          let input = {
            newData: {
              discount: +newData.discount,
              price: +newData.price,
              qty: +newData.qty,
              unit: newData.unit,
              note: newData.note,
            },
            oldData: {
              discount: oldData.discount,
              price: oldData.price,
              qty: oldData.qty,
              unit: oldData.unit,
              note: oldData.note,
            },
            partId,
            service2SoId: id,
          }

          const res = await this.$apollo.mutate({
            mutation: UPDATE_PART_TO_SERVICE_ORDER,
            variables: {
              input: input,
            },
          })

          if (res.data.updatePart2Service.isSuccessful) {
            const self = this
            self.get()
            self.$emit('update-total-price')

            return res.data.updatePart2Service
          }
        },
        delete: async (partId, id) => {
          const res = await this.$apollo.mutate({
            mutation: DELETE_PART_TO_SERVICE_ORDER,
            variables: {
              input: {
                partId,
                service2SoId: id,
              },
            },
          })

          if (res.data.deletePart2Service.isSuccessful) {
            const self = this
            self.get()
            self.$emit('update-total-price')

            return res.data.deletePart2Service
          }
        },
      }
    },
  },
  watch: {
    status() {
      this.isEditable = this.isMGMAndMO ? 
      ['Draft','Verification','InProgress','Confirmed'].includes(this.status)
        :this.status === 'Draft' || this.status === 'Verification'
    },
  },
  mounted() {
    this.get()
    this.isEditable = this.isMGMAndMO ?
      ['Draft','Verification','InProgress','Confirmed'].includes(this.status)
      :this.status === 'Draft' || this.status === 'Verification'
    setTimeout(() => {
      if (this.serviceList.length > 0) {
        this.hasData = true
      } else this.hasData = false
    }, 1000)
  },

  methods: {
    async get() {
      const res = await this.$apollo.query({
        query: GET_SERVICE_TO_SERVICE_ORDERS,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            serviceOrderId: +this.$route.params.id,
          },
        },
      })

      this.serviceList = res.data.service2ServiceOrders.service2ServiceOrders

      const service2ServiceOrders = res.data.service2ServiceOrders.service2ServiceOrders

      let kilometerData = 0
      let hourmeterData = 0
      let refrigeratorData = 0

      service2ServiceOrders.forEach((row) => {
        if (row.serviceSchedule) {
          let format = { color: 'green', label: this.$t('maintenance.status.normal') }
          if (row.serviceSchedule.status.includes('I')) {
            format = { color: 'cyan', label: this.$t('maintenance.status.inService') }
          } else if (
            row.serviceSchedule.status.includes('LO') ||
            row.serviceSchedule.status.includes('LD') ||
            row.serviceSchedule.status.includes('LH')
          ) {
            format = { color: 'red', label: this.$t('maintenance.status.lateService') }
          } else if (
            row.serviceSchedule.status.includes('SO') ||
            row.serviceSchedule.status.includes('SD') ||
            row.serviceSchedule.status.includes('SH')
          ) {
            format = {
              color: 'yellow-medium',
              label: this.$t('maintenance.status.approachingService'),
            }
          }
          row.format = format
        }

        if (row.serviceSchedule?.type == 'DistanceAndTime') {
          kilometerData += 1
        } else if (row.serviceSchedule?.type == 'Hourmeter') {
          hourmeterData += 1
        } else if (row.serviceSchedule?.type == 'Refrigerator') {
          refrigeratorData += 1
        } else {
          hourmeterData += 1
          kilometerData += 1
        }

        this.serviceIds.push(row.serviceId)
      })
      
      this.$emit('updateTotalData', kilometerData, hourmeterData, refrigeratorData)

      if (service2ServiceOrders.length > 0) {
        this.hasData = true
      } else this.hasData = false
      this.render = true
      this.isAdding = false

      return service2ServiceOrders
    },

    async addData(selected, serviceType, serviceScheduleType) {
      const res = await this.$apollo.mutate({
        mutation: CREATE_SERVICE_TO_SERVICE_ORDER,
        fetchPolicy: 'no-cache',
        variables: {
          input: {
            serviceOrderId: +this.$route.params.id,
            serviceId: +selected,
            serviceType,
            serviceScheduleType,
          },
        },
      })

      this.render = false
      this.isAdding = true

      if (res.data.createService2ServiceOrder.isSuccessful) {
        this.$mcToast.success(this.$t('global.alert.text.added'))
        setTimeout(() => {
          this.get()
        }, 1000)
      }

      this.$bvModal.hide('service-add')
    },

    async handleDelete(id, serviceId) {
      this.serviceIds = [...this.serviceIds.filter((x) => x != serviceId)]

      const res = await this.$apollo.mutate({
        mutation: DELETE_SERVICE_TO_SERVICE_ORDER,
        variables: {
          input: {
            service2SoId: id,
          },
        },
      })

      this.render = false

      if (res.data.deleteService2ServiceOrder.isSuccessful) {
        this.$mcToast.success(this.$t('global.alert.text.delete'))
        setTimeout(() => {
          this.get()
        }, 1000)
      }
    },
  },
}
</script>

<style>
#delete-accordion:hover {
  cursor: pointer;
}
</style>
